/**
 * Componente Tabs
 * Wrapper para o Tabs do Ant Design
 */

import React from "react";
import { Tabs as AntTabs } from "antd";

const Tabs = ({ tabs, activeTab, onTabChange, variant = "default", className }) => {
  const items = tabs.map(tab => ({
    key: tab.id,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {tab.icon && <tab.icon />}
        {tab.label}
        {typeof tab.badge !== "undefined" && tab.badge !== null && (
          <span
            style={{
              marginLeft: 4,
              padding: "2px 8px",
              fontSize: "0.75rem",
              fontWeight: "bold",
              background: "rgba(0,0,0,0.06)",
              borderRadius: "12px",
              minWidth: "20px",
              textAlign: "center",
              display: "inline-block"
            }}
          >
            {tab.badge}
          </span>
        )}
      </span>
    ),
  }));

  return (
    <AntTabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={items}
      className={className}
      type={variant === "pills" ? "card" : "line"}
    />
  );
};

export default Tabs;
